import { useEffect, useState } from "react";
import { UI_CONFIG, API_BASE_URL } from "../constants/index";

export default function HardLuck({ onContinue, onBackToStory, userEmail }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const handleQuillformClick = async () => {
    // Track the click in the backend
    if (userEmail) {
      try {
        await fetch(`${API_BASE_URL}/api/users/track-quillform-click`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: userEmail }),
        });
      } catch (error) {
        console.error('Failed to track quillform click:', error);
      }
    }
    
    // Open the Quillform
    window.open('https://juniorisep.quillforms.app/forms/recrutement-cdp-2026-2027', '_blank');
  };



  return (
    <div className="w-full h-screen bg-gradient-to-b from-orange-500 via-orange-600 to-yellow-600 flex flex-col justify-center items-center px-4">
      {/* Logo */}
      <div className="mb-6">
        <img 
          src="/static/juniorisep.svg" 
          alt="JUNIORISEP Logo" 
          className="w-16 h-16 object-contain filter brightness-0 invert"
        />
      </div>

      {/* Title */}
      <h1 className="text-3xl md:text-4xl font-bold text-white mb-4 text-center">
        Pas de chance !
      </h1>

      {/* Content Card */}
      <div className="bg-white rounded-2xl p-6 w-full max-w-sm mx-auto mb-6 text-center shadow-lg">
        <p className="text-gray-600 text-sm mb-6">
          Malheureusement, tu n'as pas gagné de prix cette fois-ci. Mais ne t'inquiète pas ! Nous organisons un <strong>after work</strong> le 10 septembre ! Plus de détails sur Instagram <a href="https://www.instagram.com/juniorisep/" target="_blank" rel="noopener noreferrer" className="text-orange-600 underline font-semibold">@juniorisep</a>.
        </p>

        <div className="space-y-3">
          <button
            onClick={handleQuillformClick}
            className="w-full bg-gradient-to-r from-orange-500 to-yellow-500 text-white font-bold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 active:scale-95 text-sm"
          >
            Postuler
          </button>
          <button
            onClick={onBackToStory}
            className="w-full bg-gray-200 text-gray-700 font-semibold py-3 px-6 rounded-xl hover:bg-gray-300 transition-all duration-300 text-sm"
          >
            Retour au début
          </button>
        </div>
      </div>

      {/* Branding */}
      <p className="text-white/80 text-xs text-center">
        Créé par <span className="font-semibold">Junior ISEP</span>
      </p>
    </div>
  );
}
